import { createContext, useContext, useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export function useHwLibraryType() { return useContext(HwLibraryTypeContext).value; }
const HwLibraryTypeContext = /*#__PURE__*/ createContext({ value: "missing-hw-library-context" });
export function HwLibraryTypeProvider(props) { const ctx = useMemo(() => ({ value: props.value }), [props.value]); return /*#__PURE__*/ _jsx(HwLibraryTypeContext.Provider, { value: ctx, children: props.children }); }
